import { extendTheme } from "@chakra-ui/react";
import "./fonts.css";

import "@fontsource/poppins";

const customTheme = extendTheme({
  fonts: {
    heading: "TorsosPro, sans-serif",
    body: "Poppins, sans-serif",
    text: "Poppins, sans-serif",
  },
  colors: {
    brand: {
      50: "rgba(29, 33, 50, 1)",
      100: "rgba(34, 40, 61, 1)",
      150: "rgba(170, 87, 225, 1)",
      200: "rgba(215, 255, 66, 1)",
    },
  },
});

export default customTheme;
